module.exports = __webpack_public_path__ + "img/Categories_bg_08.856e0052.jpg";